export const countries = {
  'pt-BR': [
    { name: 'Afeganistão' },
    { name: 'África do Sul' },
    { name: 'Albânia' },
    { name: 'Alemanha' },
    { name: 'Andorra' },
    { name: 'Angola' },
    { name: 'Antígua e Barbuda' },
    { name: 'Arábia Saudita' },
    { name: 'Argélia' },
    { name: 'Argentina' },
    { name: 'Armênia' },
    { name: 'Austrália' },
    { name: 'Áustria' },
    { name: 'Azerbaijão' },
    { name: 'Bahamas' },
    { name: 'Bahrein' },
    { name: 'Bangladesh' },
    { name: 'Barbados' },
    { name: 'Belarus' },
    { name: 'Bélgica' },
    { name: 'Belize' },
    { name: 'Benin' },
    { name: 'Bermudas' },
    { name: 'Bolívia' },
    { name: 'Bósnia e Herzegovina' },
    { name: 'Botsuana' },
    { name: 'Brasil' },
    { name: 'Brunei' },
    { name: 'Bulgária' },
    { name: 'Burkina Faso' },
    { name: 'Burundi' },
    { name: 'Butão' },
    { name: 'Cabo Verde' },
    { name: 'Camarões' },
    { name: 'Camboja' },
    { name: 'Canadá' },
    { name: 'Catar' },
    { name: 'Cazaquistão' },
    { name: 'Chade' },
    { name: 'Chile' },
    { name: 'China' },
    { name: 'Chipre' },
    { name: 'Colômbia' },
    { name: 'Comores' },
    { name: 'Congo' },
    { name: 'Coreia do Norte' },
    { name: 'Coreia do Sul' },
    { name: 'Costa do Marfim' },
    { name: 'Costa Rica' },
    { name: 'Croácia' },
    { name: 'Cuba' },
    { name: 'Dinamarca' },
    { name: 'Djibuti' },
    { name: 'Dominica' },
    { name: 'Egito' },
    { name: 'El Salvador' },
    { name: 'Emirados Árabes Unidos' },
    { name: 'Equador' },
    { name: 'Eritreia' },
    { name: 'Eslováquia' },
    { name: 'Eslovênia' },
    { name: 'Espanha' },
    { name: 'Estados Unidos' },
    { name: 'Estônia' },
    { name: 'Eswatini' },
    { name: 'Etiópia' },
    { name: 'Fiji' },
    { name: 'Filipinas' },
    { name: 'Finlândia' },
    { name: 'França' },
    { name: 'Gabão' },
    { name: 'Gâmbia' },
    { name: 'Gana' },
    { name: 'Geórgia' },
    { name: 'Granada' },
    { name: 'Grécia' },
    { name: 'Guatemala' },
    { name: 'Guiana' },
    { name: 'Guiné' },
    { name: 'Guiné Equatorial' },
    { name: 'Guiné-Bissau' },
    { name: 'Haiti' },
    { name: 'Holanda' },
    { name: 'Honduras' },
    { name: 'Hungria' },
    { name: 'Iêmen' },
    { name: 'Ilhas Cayman' },
    { name: 'Ilhas Cook' },
    { name: 'Ilhas Marshall' },
    { name: 'Ilhas Salomão' },
    { name: 'Ilhas Virgens Americanas' },
    { name: 'Ilhas Virgens Britânicas' },
    { name: 'Índia' },
    { name: 'Indonésia' },
    { name: 'Irã' },
    { name: 'Iraque' },
    { name: 'Irlanda' },
    { name: 'Islândia' },
    { name: 'Israel' },
    { name: 'Itália' },
    { name: 'Jamaica' },
    { name: 'Japão' },
    { name: 'Jordânia' },
    { name: 'Kiribati' },
    { name: 'Kuwait' },
    { name: 'Laos' },
    { name: 'Lesoto' },
    { name: 'Letônia' },
    { name: 'Líbano' },
    { name: 'Libéria' },
    { name: 'Líbia' },
    { name: 'Liechtenstein' },
    { name: 'Lituânia' },
    { name: 'Luxemburgo' },
    { name: 'Madagascar' },
    { name: 'Malásia' },
    { name: 'Malawi' },
    { name: 'Maldivas' },
    { name: 'Mali' },
    { name: 'Malta' },
    { name: 'Marrocos' },
    { name: 'Maurício' },
    { name: 'Mauritânia' },
    { name: 'México' },
    { name: 'Micronésia' },
    { name: 'Moçambique' },
    { name: 'Moldávia' },
    { name: 'Mônaco' },
    { name: 'Mongólia' },
    { name: 'Montenegro' },
    { name: 'Namíbia' },
    { name: 'Nauru' },
    { name: 'Nepal' },
    { name: 'Nicarágua' },
    { name: 'Níger' },
    { name: 'Nigéria' },
    { name: 'Niue' },
    { name: 'Noruega' },
    { name: 'Nova Zelândia' },
    { name: 'Omã' },
    { name: 'Palau' },
    { name: 'Palestina' },
    { name: 'Panamá' },
    { name: 'Papua Nova Guiné' },
    { name: 'Paquistão' },
    { name: 'Paraguai' },
    { name: 'Peru' },
    { name: 'Polônia' },
    { name: 'Portugal' },
    { name: 'Quênia' },
    { name: 'Quirguistão' },
    { name: 'Reino Unido' },
    { name: 'República Centro-Africana' },
    { name: 'República Dominicana' },
    { name: 'República Tcheca' },
    { name: 'Romênia' },
    { name: 'Ruanda' },
    { name: 'Rússia' },
    { name: 'Samoa' },
    { name: 'San Marino' },
    { name: 'Santa Lúcia' },
    { name: 'São Cristóvão e Nevis' },
    { name: 'São Tomé e Príncipe' },
    { name: 'São Vicente e Granadinas' },
    { name: 'Senegal' },
    { name: 'Sérvia' },
    { name: 'Seychelles' },
    { name: 'Serra Leoa' },
    { name: 'Singapura' },
    { name: 'Síria' },
    { name: 'Somália' },
    { name: 'Sri Lanka' },
    { name: 'Suazilândia' },
    { name: 'Sudão' },
    { name: 'Sudão do Sul' },
    { name: 'Suécia' },
    { name: 'Suíça' },
    { name: 'Suriname' },
    { name: 'Tailândia' },
    { name: 'Taiwan' },
    { name: 'Tajiquistão' },
    { name: 'Tanzânia' },
    { name: 'Timor-Leste' },
    { name: 'Togo' },
    { name: 'Tonga' },
    { name: 'Trinidad e Tobago' },
    { name: 'Tunísia' },
    { name: 'Turcomenistão' },
    { name: 'Turquia' },
    { name: 'Tuvalu' },
    { name: 'Ucrânia' },
    { name: 'Uganda' },
    { name: 'Uruguai' },
    { name: 'Uzbequistão' },
    { name: 'Vanuatu' },
    { name: 'Vaticano' },
    { name: 'Venezuela' },
    { name: 'Vietnã' },
    { name: 'Zâmbia' },
    { name: 'Zimbábue' }
  ],
  en: [
    { name: 'Afghanistan' },
    { name: 'South Africa' },
    { name: 'Albania' },
    { name: 'Germany' },
    { name: 'Andorra' },
    { name: 'Angola' },
    { name: 'Antigua and barbuda' },
    { name: 'Saudi Arabia' },
    { name: 'Algeria' },
    { name: 'Argentina' },
    { name: 'Armenia' },
    { name: 'Australia' },
    { name: 'Austria' },
    { name: 'Azerbaijan' },
    { name: 'Bahamas' },
    { name: 'Bahrain' },
    { name: 'Bangladesh' },
    { name: 'Barbados' },
    { name: 'Belarus' },
    { name: 'Belgium' },
    { name: 'Belize' },
    { name: 'Benin' },
    { name: 'Bermudas' },
    { name: 'Bolivia' },
    { name: 'Bosnia and Herzegovina' },
    { name: 'Botswana' },
    { name: 'Brazil' },
    { name: 'Brunei' },
    { name: 'Bulgaria' },
    { name: 'Burkina Faso' },
    { name: 'Burundi' },
    { name: 'Bhutan' },
    { name: 'Cape Green' },
    { name: 'Cameroon' },
    { name: 'Cambodia' },
    { name: 'Canada' },
    { name: 'Qatar' },
    { name: 'Kazakhstan' },
    { name: 'Chad' },
    { name: 'Chile' },
    { name: 'China' },
    { name: 'Cyprus' },
    { name: 'Colombia' },
    { name: 'Comoros' },
    { name: 'Congo' },
    { name: 'North Korea' },
    { name: 'South Korea' },
    { name: 'Costa do Marfim' },
    { name: 'Costa Rica' },
    { name: 'Croatia' },
    { name: 'Cuba' },
    { name: 'Denmark' },
    { name: 'Djibuti' },
    { name: 'Dominica' },
    { name: 'Egypt' },
    { name: 'El Salvador' },
    { name: 'United Arab Emirates' },
    { name: 'Ecuador' },
    { name: 'Eritreia' },
    { name: 'Slovakia' },
    { name: 'Slovenia' },
    { name: 'Spain' },
    { name: 'U.S' },
    { name: 'Estonia' },
    { name: 'Eswatini' },
    { name: 'Ethiopia' },
    { name: 'Fiji' },
    { name: 'Philippines' },
    { name: 'Finland' },
    { name: 'France' },
    { name: 'Gabon' },
    { name: 'Gambia' },
    { name: 'Gana' },
    { name: 'Georgia' },
    { name: 'Granada' },
    { name: 'Greece' },
    { name: 'Guatemala' },
    { name: 'Guiana' },
    { name: 'Guinea' },
    { name: 'Equatorial Guinea' },
    { name: 'Guinea Bissau' },
    { name: 'Haiti' },
    { name: 'Netherlands' },
    { name: 'Honduras' },
    { name: 'Hungary' },
    { name: 'Yemen' },
    { name: 'Cayman Islands' },
    { name: 'cook islands' },
    { name: 'Marshall Islands' },
    { name: 'Solomon Islands' },
    { name: 'US Virgin Islands' },
    { name: 'british virgin islands' },
    { name: 'India' },
    { name: 'Indonesia' },
    { name: 'Iran' },
    { name: 'Iraq' },
    { name: 'Ireland' },
    { name: 'Iceland' },
    { name: 'Israel' },
    { name: 'Italy' },
    { name: 'Jamaica' },
    { name: 'Japan' },
    { name: 'Jordan' },
    { name: 'Kiribati' },
    { name: 'Kuwait' },
    { name: 'Laos' },
    { name: 'Lesoto' },
    { name: 'Latvia' },
    { name: 'Líbano' },
    { name: 'Libéria' },
    { name: 'Líbia' },
    { name: 'Liechtenstein' },
    { name: 'Lithuania' },
    { name: 'Luxembourg' },
    { name: 'Madagascar' },
    { name: 'Malaysia' },
    { name: 'Malawi' },
    { name: 'Maldives' },
    { name: 'Mali' },
    { name: 'Malta' },
    { name: 'Morocco' },
    { name: 'Mauritius' },
    { name: 'Mauritania' },
    { name: 'Mexico' },
    { name: 'Micronesia' },
    { name: 'Mozambique' },
    { name: 'Moldávia' },
    { name: 'Monaco' },
    { name: 'Mongolia' },
    { name: 'Montenegro' },
    { name: 'namibia' },
    { name: 'Nauru' },
    { name: 'Nepal' },
    { name: 'Nicaragua' },
    { name: 'Níger' },
    { name: 'Nigeria' },
    { name: 'Niue' },
    { name: 'Norway' },
    { name: 'New Zealand' },
    { name: 'Oman' },
    { name: 'Palau' },
    { name: 'Palestine' },
    { name: 'Panama' },
    { name: 'Papua New Guinea' },
    { name: 'Pakistan' },
    { name: 'Paraguay' },
    { name: 'Peru' },
    { name: 'Poland' },
    { name: 'Portugal' },
    { name: 'Kenya' },
    { name: 'Kyrgyzstan' },
    { name: 'UK' },
    { name: 'Central African Republic' },
    { name: 'Dominican Republic' },
    { name: 'Czech republic' },
    { name: 'Romania' },
    { name: 'Ruanda' },
    { name: 'Russia' },
    { name: 'Samoa' },
    { name: 'San Marino' },
    { name: 'Santa Lúcia' },
    { name: 'Saint Kitts and Nevis' },
    { name: 'Sao Tome and Principe' },
    { name: 'Saint Vincent and the Grenadines' },
    { name: 'Senegal' },
    { name: 'Serbia' },
    { name: 'Seychelles' },
    { name: 'Sierra Leone' },
    { name: 'Singapura' },
    { name: 'Syria' },
    { name: 'Somalia' },
    { name: 'Sri Lanka' },
    { name: 'Suazilândia' },
    { name: 'Sudan' },
    { name: 'Southern Sudan' },
    { name: 'Sweden' },
    { name: 'Switzerland' },
    { name: 'Suriname' },
    { name: 'thailand' },
    { name: 'Taiwan' },
    { name: 'Tajikistan' },
    { name: 'Tanzania' },
    { name: 'Timor-Leste' },
    { name: 'Togo' },
    { name: 'Tonga' },
    { name: 'Trinidad e Tobago' },
    { name: 'Tunisia' },
    { name: 'Turkmenistan' },
    { name: 'Türkiye' },
    { name: 'Tuvalu' },
    { name: 'Ukraine' },
    { name: 'Uganda' },
    { name: 'Uruguay' },
    { name: 'uzbekistan' },
    { name: 'Vanuatu' },
    { name: 'Vatican' },
    { name: 'Venezuela' },
    { name: 'Vietnam' },
    { name: 'Zambia' },
    { name: 'Zimbabwe' }
  ],
  es: [
    { name: 'Afganistán' },
    { name: 'Sudáfrica' },
    { name: 'Albania' },
    { name: 'Alemania' },
    { name: 'Andorra' },
    { name: 'Angola' },
    { name: 'Antigua y Barbuda' },
    { name: 'Arabia Saudita' },
    { name: 'Argelia' },
    { name: 'Argentina' },
    { name: 'Armenia' },
    { name: 'Australia' },
    { name: 'Austria' },
    { name: 'Azerbaiyán' },
    { name: 'Bahamas' },
    { name: 'Baréin' },
    { name: 'Bangladesh' },
    { name: 'Barbados' },
    { name: 'Bielorrusia' },
    { name: 'Bélgica' },
    { name: 'Belice' },
    { name: 'Benín' },
    { name: 'islas Bermudas' },
    { name: 'Bolivia' },
    { name: 'Bosnia y Herzegovina' },
    { name: 'Botsuana' },
    { name: 'Brasil' },
    { name: 'Brunéi' },
    { name: 'Bulgaria' },
    { name: 'Burkina Faso' },
    { name: 'Burundi' },
    { name: 'Bután' },
    { name: 'Cabo Verde' },
    { name: 'Camerún' },
    { name: 'Camboya' },
    { name: 'Canadá' },
    { name: 'Katar' },
    { name: 'Kazajistán' },
    { name: 'Chad' },
    { name: 'Chile' },
    { name: 'China' },
    { name: 'Chipre' },
    { name: 'Colombia' },
    { name: 'Comoras' },
    { name: 'Congo' },
    { name: 'Corea del Norte' },
    { name: 'Corea del Sur' },
    { name: 'Costa de Marfil' },
    { name: 'Costa Rica' },
    { name: 'Croacia' },
    { name: 'Cuba' },
    { name: 'Dinamarca' },
    { name: 'Yibuti' },
    { name: 'dominicana' },
    { name: 'Egipto' },
    { name: 'El Salvador' },
    { name: 'Emiratos Árabes Unidos' },
    { name: 'Ecuador' },
    { name: 'eritrea' },
    { name: 'Eslovaquia' },
    { name: 'Eslovenia' },
    { name: 'España' },
    { name: 'Estados Unidos' },
    { name: 'Estonia' },
    { name: 'Eswatini' },
    { name: 'Etiopía' },
    { name: 'Fiji' },
    { name: 'Filipinas' },
    { name: 'Finlandia' },
    { name: 'Francia' },
    { name: 'Gabón' },
    { name: 'Gambia' },
    { name: 'Gana' },
    { name: 'Georgia' },
    { name: 'Granada' },
    { name: 'Grecia' },
    { name: 'Guatemala' },
    { name: 'Guiana' },
    { name: 'Guinea' },
    { name: 'Guinea Ecuatorial' },
    { name: 'Guinea-Bisáu' },
    { name: 'Haití' },
    { name: 'Países Bajos' },
    { name: 'Honduras' },
    { name: 'Hungría' },
    { name: 'Yemen' },
    { name: 'Islas Caimán' },
    { name: 'Islas Cook' },
    { name: 'Islas Marshall' },
    { name: 'Islas Salomón' },
    { name: 'Islas Vírgenes de EE.UU' },
    { name: 'islas vírgenes británicas' },
    { name: 'India' },
    { name: 'Indonesia' },
    { name: 'Voluntad' },
    { name: 'Irak' },
    { name: 'Irlanda' },
    { name: 'Islandia' },
    { name: 'Israel' },
    { name: 'Italia' },
    { name: 'Jamaica' },
    { name: 'Japón' },
    { name: 'Jordán' },
    { name: 'Kiribati' },
    { name: 'Kuwait' },
    { name: 'Laos' },
    { name: 'Lesoto' },
    { name: 'letonia' },
    { name: 'Líbano' },
    { name: 'Libéria' },
    { name: 'Libia' },
    { name: 'Liechtenstein' },
    { name: 'Lituania' },
    { name: 'luxemburgo' },
    { name: 'Madagascar' },
    { name: 'Malasia' },
    { name: 'Malawi' },
    { name: 'Maldivas' },
    { name: 'Mali' },
    { name: 'Malta' },
    { name: 'Marrocos' },
    { name: 'Maurício' },
    { name: 'Mauritânia' },
    { name: 'México' },
    { name: 'Micronésia' },
    { name: 'Mozambique' },
    { name: 'Moldavia' },
    { name: 'Mónaco' },
    { name: 'Mongolia' },
    { name: 'Montenegro' },
    { name: 'Namibia' },
    { name: 'Nauru' },
    { name: 'Nepal' },
    { name: 'Nicaragua' },
    { name: 'Níger' },
    { name: 'Nigeria' },
    { name: 'Niue' },
    { name: 'Noruega' },
    { name: 'Nueva Zelanda' },
    { name: 'Omã' },
    { name: 'Palau' },
    { name: 'Palestina' },
    { name: 'Panamá' },
    { name: 'Papúa Nueva Guinea' },
    { name: 'Pakistán' },
    { name: 'Paraguay' },
    { name: 'Perú' },
    { name: 'Polonia' },
    { name: 'Portugal' },
    { name: 'Kenia' },
    { name: 'Kirguistán' },
    { name: 'Reino Unido' },
    { name: 'República Centroafricana' },
    { name: 'República Dominicana' },
    { name: 'República Checa' },
    { name: 'Rumania' },
    { name: 'Ruanda' },
    { name: 'Rusia' },
    { name: 'Samoa' },
    { name: 'San Marino' },
    { name: 'Santa Lucía' },
    { name: 'San Cristóbal y Nieves' },
    { name: 'San Tome y Principe' },
    { name: 'San Vicente y las Granadinas' },
    { name: 'Senegal' },
    { name: 'Serbia' },
    { name: 'Seychelles' },
    { name: 'Sierra Leona' },
    { name: 'Singapur' },
    { name: 'Siria' },
    { name: 'Somália' },
    { name: 'Sri Lanka' },
    { name: 'Suazilandia' },
    { name: 'Sudán' },
    { name: 'Sudán del Sur' },
    { name: 'Suecia' },
    { name: 'Suiza' },
    { name: 'Surinam' },
    { name: 'tailandia' },
    { name: 'Taiwan' },
    { name: 'Tayikistán' },
    { name: 'Tanzania' },
    { name: 'Timor-Leste' },
    { name: 'Togo' },
    { name: 'Tonga' },
    { name: 'Trinidad e Tobago' },
    { name: 'Túnez' },
    { name: 'turkmenistán' },
    { name: 'Turquía' },
    { name: 'Tuvalu' },
    { name: 'Ucrania' },
    { name: 'Uganda' },
    { name: 'Uruguay' },
    { name: 'uzbekistán' },
    { name: 'Vanuatu' },
    { name: 'Vaticano' },
    { name: 'Venezuela' },
    { name: 'Vietnam' },
    { name: 'Zambia' },
    { name: 'Zimbabue' }
  ]
};

export type CountryOption = { name: string };

export function getCountries(locale?: string): CountryOption[] {
  const key = (locale || 'pt-BR') as keyof typeof countries;
  return countries[key] ?? countries['pt-BR'];
}
